const orderProdTypeLabels: Record<string, string> = {
  '10': '非消耗型',
  '20': '消耗型',
  '30': '订阅型',
  '31': '非自动续期订阅',
  '32': '自动续期订阅',
}

export function getOrderProdTypeLabel(val: unknown): string {
  if (val === null || val === undefined || val === '') return '--'
  return orderProdTypeLabels[String(val)] ?? '--'
}
